import { GetServerSideProps } from 'next';
import React from 'react';
import styled from 'styled-components';

import { DefaultPage } from '@klappir/container/graphcms';
import { H3 } from '@klappir/ui/text';
import { fonts } from '@klappir/util/styles';

import { MFNclient, RequestLang } from '../../../../../libs/data/mfn/src';

const NewsItemHTMLWrapper = styled.div`
  width: 100%;
  line-height: 1.6;
`;

const ArticleHero = styled.div`
  display: flex;
`;

const ContentWrapper = styled.div`
  width: 40%;
  margin: auto;
  padding-top: 50px;
  @media only screen and (max-width: 800px) {
    padding-top: 10px;
    width: 85%;
  }
`;

const ArticleHeading = styled(H3).attrs({ as: 'h1' })`
  font-weight: ${fonts.weight.semibold};
  @media only screen and (max-width: 800px) {
    margin-bottom: 40px;
  }
`;

const InvestorNewsItem = ({ data, slug, locale }) => {
  const newsitem = data.value.items[0];

  return (
    <DefaultPage localizations={locale}>
      <ArticleHero>
        <ContentWrapper>
          <div>
            <ArticleHeading>{newsitem?.content?.title}</ArticleHeading>
          </div>
          <NewsItemHTMLWrapper
            dangerouslySetInnerHTML={{ __html: newsitem?.content?.html }}
          />
        </ContentWrapper>
      </ArticleHero>
    </DefaultPage>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const lang = context?.params?.slug[0] as RequestLang;
  const slug = context?.params?.slug[1];

  const [data] = await Promise.allSettled([
    MFNclient({ type: 'ir', lang: lang, slug: slug }),
  ]);

  if (!data) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      data,
      slug,
      locale: context.locale,
    },
  };
};

export default InvestorNewsItem;
